angular.module('aq.filters').filter('html', function($sce) {
    return $sce.trustAsHtml;
});